const applicationPaths = {};

applicationPaths.WELCOME = '/welcome';
applicationPaths.DASHBOARD = '/dashboard';
applicationPaths.COMMUNITY = '/community';
applicationPaths.PAGES = '/pages';
applicationPaths.CONTACTS = '/contacts';
applicationPaths.INBOX = '/inbox';
applicationPaths.CAMPAIGNS = '/campaigns';
applicationPaths.AUTHENTICATION_CALLBACK = '/authentication-callback';
applicationPaths.LOGGED_OUT = '/logged-out';

const oneLevelPaths = [
  applicationPaths.WELCOME,
  applicationPaths.DASHBOARD,
  applicationPaths.COMMUNITY,
  applicationPaths.PAGES,
  applicationPaths.CONTACTS,
  applicationPaths.INBOX,
  applicationPaths.CAMPAIGNS,
  applicationPaths.AUTHENTICATION_CALLBACK,
  applicationPaths.LOGGED_OUT
];

const twoLevelPaths = [
  applicationPaths.COMMUNITY,
  applicationPaths.PAGES,
  applicationPaths.CONTACTS,
  applicationPaths.INBOX,
  applicationPaths.CAMPAIGNS
];

export function isApplicationPath(path) {

  if (oneLevelPaths.indexOf(path) !== -1) {
    return true;
  }

  for (let applicationPath of twoLevelPaths) {

    if (path.indexOf((applicationPath + '/')) !== -1) {
      return true;
    }

  }

  return false;

}

export function isCommunityPath(path) {

  return path.indexOf(applicationPaths.COMMUNITY) !== -1;

}

export function parse(url, pattern) {
  // Create a new URL object
  const urlObj = new URL(url);

  // Split both the URL pathname and pattern into parts
  const urlParts = urlObj.pathname.split('/').filter(Boolean);
  const patternParts = pattern.split('/').filter(Boolean);

  // If the URL and pattern have a different number of parts, they don't match
  if (urlParts.length !== patternParts.length) {
    return null;
  }

  // Initialize an empty object to store parameters
  let params = {};

  // Loop over the pattern parts
  for (let i = 0; i < patternParts.length; i++) {
    // If the pattern part starts with ':', it's a named parameter
    if (patternParts[i].startsWith(':')) {
      const paramName = patternParts[i].substring(1);
      params[paramName] = urlParts[i];
    }
    // Otherwise, the URL part must exactly match the pattern part
    else if (urlParts[i] !== patternParts[i]) {
      return null;
    }
  }

  // If we've made it here, all parts of the URL either match
  // the corresponding part of the pattern, or have been captured as parameters
  return params;
}